const rootStyle = () =>
  typeof window !== 'undefined' && window.getComputedStyle ? window.getComputedStyle(document.documentElement) : null;

/**
 * Design tokens' values, read at runtime, for libraries that take plain colours (Maps, Highcharts), from a single
 * style lookup: each lookup makes the browser recalculate styles. The fallbacks are the tokens' values, for tests and
 * before the stylesheet loads.
 * @param {Object<string, string>} fallbacks CSS custom property → fallback, e.g. { '--color-primary': '#5667ff' }
 * @returns {Object<string, string>} CSS custom property → value
 */
export function cssTokens(fallbacks) {
  const style = rootStyle();
  return Object.fromEntries(
    Object.entries(fallbacks).map(([name, fallback]) => [name, style?.getPropertyValue(name).trim() || fallback]),
  );
}

/**
 * One design token's value; see cssTokens() for several.
 * @param {string} name a CSS custom property, e.g. '--color-primary'
 * @param {string} fallback
 * @returns {string}
 */
export default function cssToken(name, fallback) {
  return cssTokens({ [name]: fallback })[name];
}
